<template>
    <modal :name="modalName" @afterHide="actionAfterHide">
        <div class="modal-title">
            <span>
                <b>Do you have account to pair?</b>
                <span class="modal-desc">Log in with your details to pair the account.</span>
            </span>
            <img src="../../assets/images/x-icon-grey.svg" alt="X Icon" @click="actionHide">
        </div>
        <text-input label="Username" type="dark" ref="username" @keyup.enter.native="actionPair"/>
        <password-input label="Password" type="dark" ref="password" @keyup.enter.native="actionPair"/>
        <text-button label="Pair account" :loading-state="loadingState" @click="actionPair"/>
    </modal>
</template>

<script>
    import Modal from "../components/Modal";
    import TextInput from "../components/TextInput";
    import TextButton from "../components/TextButton";
    import PasswordInput from "../components/PasswordInput";

    export default {
        name: "AccountPairModal",
        components: {PasswordInput, TextButton, TextInput, Modal},
        props: {
            platformSlug: {
                type: String,
                required: true,
            }
        },
        computed: {
            modalName() {
                return this.$enums.ModalNameEnum.ACCOUNT_PAIR + '-' + this.platformSlug;
            }
        },
        data() {
            return {
                loadingState: false,
            }
        },
        methods: {
            actionHide() {
                this.$modals.hide(this.modalName);
            },
            actionPair() {
                this.loadingState = true;

                let username = this.$refs.username.value ?? '';
                let password = this.$refs.password.value ?? '';

                this.$api.pairAccount({
                    data: {
                        username: username,
                        password: password,
                        platformSlug: this.platformSlug
                    }
                }).then(() => {
                    this.$parent.$parent.init();
                    this.actionHide();
                }).finally(this.loadingState = false);
            },
            actionAfterHide() {
                this.$refs.username.value = '';
                this.$refs.password.value = '';
            }
        }
    }
</script>